import { api } from '../api';
import type { Expense } from '../types';

export const addExpense = (expenseData: Omit<Expense, 'id' | 'createdAt'>) => api.expenses.add(expenseData);
export const updateExpense = (id: string, expenseData: Partial<Expense>) => api.expenses.update(id, expenseData);
export const deleteExpense = (id: string) => api.expenses.delete(id);
export const getGroupExpenses = (groupId: string) => api.expenses.getGroupExpenses(groupId);
export const subscribeToGroupExpenses = (groupId: string, callback: (expenses: Expense[]) => void) => api.expenses.subscribe(groupId, callback);
